"use strict";
const _ = require('lodash');
class Invariantor {
    constructor(invoiceToEnsure) {
        this.invoice = invoiceToEnsure;
        this.invoice.invoiceRows = invoiceToEnsure.invoiceRows || [];
    }
    ensureQuantities() {
        this.invoice.invoiceRows = this.invoice.invoiceRows.map(row => ({
            ...row,
            deliveredQuantity: row.deliveredQuantity || 0,
            orderedQuantity: row.orderedQuantity || 0,
            total: row.total || 0,
        }));
        return this;
    }
    ensureRecycle() {
        const shouldHavePant = !_.includes(['returnToSupplier'], this.invoice.invoiceOrigin);
        this.invoice.invoiceRows = this.invoice.invoiceRows.map(row => {
            const totalRecycle = row.article && shouldHavePant && row.discount !== 100
                ? (row.article.recycleAmount || 0) * row.deliveredQuantity
                : 0;
            const totalIncludingRecycle = row.total + totalRecycle;
            return {
                ...row,
                totalRecycle,
                totalIncludingRecycle,
            };
        });
        return this;
    }
    value() {
        return { ...this.invoice };
    }
}
// invariants for the entity goes here
module.exports = invoiceToEnsure => {
    const hadRows = !!invoiceToEnsure.orderRows;
    const ensured = new Invariantor(invoiceToEnsure)
        .ensureQuantities()
        .ensureRecycle()
        .value();
    if (!hadRows) {
        delete ensured.orderRows;
    }
    return ensured;
};
